import { css } from "styled-components";
const paddings = ({ pb, pl, pr, pt, theme })=>css`
  ${pb && `padding-bottom: ${theme.sizes.paddings[pb] || theme.sizes[pb] || pb}`};
  ${pl && `padding-left: ${theme.sizes.paddings[pl] || theme.sizes[pl] || pl}`};
  ${pr && `padding-right: ${theme.sizes.paddings[pr] || theme.sizes[pr] || pr}`};
  ${pt && `padding-top: ${theme.sizes.paddings[pt] || theme.sizes[pt] || pt}`};
`;
export default paddings;
